
import { useState, useRef, useEffect } from 'react';

const TESTIMONIALS = [
  {
    id: 1,
    quote: 'Orsonet to nie tylko wykonawca, ale partner biznesowy. Nasza nowa strona generuje 3x więcej leadów, a pozycje w Google rosną każdego miesiąca. Profesjonalizm na najwyższym poziomie.',
    name: 'Marek Kowalski',
    role: 'CEO, Prestige Estate',
    avatar: 'https://public.readdy.ai/ai/img_res/79b629a07e04a7a0f4614af8e9bcc78b.jpg',
    rating: 5,
    color: '#00d4ff',
  },
  {
    id: 2,
    quote: 'Wirtualna wycieczka 360° i nowa strona zwiększyły nasze rezerwacje o 340% w ciągu pół roku. Orsonet rozumie, czego potrzebuje branża hotelarska.',
    name: 'Anna Wiśniewska',
    role: 'Dyrektor, Hotel Panorama',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20executive%20portrait%20confident%20manager%20natural%20lighting%20corporate%20headshot%20neutral%20background%20high%20quality%20photography&width=200&height=200&seq=av2&orientation=squarish',
    rating: 5,
    color: '#00ff88',
  },
  {
    id: 3,
    quote: 'Agent AI na naszej stronie obsługuje 70% zapytań automatycznie. Oszczędzamy czas i pieniądze, a klienci są zachwyceni szybkością odpowiedzi.',
    name: 'Dr. Piotr Nowak',
    role: 'Właściciel, Klinika Zdrowie+',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20doctor%20male%20portrait%20confident%20medical%20professional%20natural%20lighting%20headshot%20neutral%20background%20high%20quality%20photography&width=200&height=200&seq=av3&orientation=squarish',
    rating: 5,
    color: '#ff6b9d',
  },
  {
    id: 4,
    quote: 'SEO i Google Wizytówka przyniosły nam top 1 dla kluczowych fraz w Warszawie. Liczba klientów z Google wzrosła o 180% w 4 miesiące.',
    name: 'Katarzyna Lewandowska',
    role: 'Partner, Kancelaria Lex Premium',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20lawyer%20woman%20portrait%20confident%20attorney%20natural%20lighting%20corporate%20headshot%20neutral%20background%20high%20quality%20photography&width=200&height=200&seq=av4&orientation=squarish',
    rating: 5,
    color: '#00d4ff',
  },
];

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const startAuto = () => {
    intervalRef.current = setInterval(() => {
      setActive((a) => (a + 1) % TESTIMONIALS.length);
    }, 5000);
  };

  useEffect(() => {
    startAuto();
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, []);

  const goTo = (i: number) => {
    setActive(i);
    if (intervalRef.current) clearInterval(intervalRef.current);
    startAuto();
  };

  const t = TESTIMONIALS[active];

  return (
    <section className="py-32 bg-[#070707] relative overflow-hidden">
      {/* BG glow */}
      <div
        className="absolute inset-0 pointer-events-none transition-all duration-1000"
        style={{
          background: `radial-gradient(ellipse at 50% 50%, ${t.color}08 0%, transparent 60%)`,
        }}
      />

      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#00d4ff] text-xs uppercase tracking-[3px] font-semibold mb-4">Opinie klientów</p>
          <h2 className="text-4xl md:text-5xl font-black text-white">Co mówią nasi klienci</h2>
        </div>

        {/* Main card */}
        <div
          className="relative rounded-3xl border border-white/10 bg-white/[0.03] backdrop-blur-sm p-10 md:p-16 mb-8 overflow-hidden transition-all duration-500"
          style={{ borderColor: `${t.color}20` }}
        >
          {/* Quote icon */}
          <div
            className="absolute top-8 right-10 text-[120px] font-black leading-none select-none pointer-events-none"
            style={{ color: `${t.color}08` }}
          >
            "
          </div>

          {/* Stars */}
          <div className="flex gap-1 mb-8">
            {Array.from({ length: t.rating }).map((_, i) => (
              <i key={i} className="ri-star-fill text-yellow-400 text-lg" />
            ))}
          </div>

          {/* Quote */}
          <p
            className="text-xl md:text-2xl text-white/80 font-light leading-relaxed mb-10 relative z-10"
            style={{
              opacity: 1,
              transition: 'opacity 0.4s ease',
            }}
          >
            "{t.quote}"
          </p>

          {/* Author */}
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full overflow-hidden border-2 flex-shrink-0" style={{ borderColor: t.color }}>
              <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
            </div>
            <div>
              <p className="text-white font-bold text-base">{t.name}</p>
              <p className="text-white/40 text-sm">{t.role}</p>
            </div>
            <div
              className="ml-auto px-4 py-2 rounded-full text-xs font-bold"
              style={{ background: `${t.color}15`, color: t.color, border: `1px solid ${t.color}30` }}
            >
              Zweryfikowany klient
            </div>
          </div>

          {/* Bottom accent line */}
          <div
            className="absolute bottom-0 left-0 right-0 h-0.5"
            style={{ background: `linear-gradient(90deg, transparent, ${t.color}, transparent)` }}
          />
        </div>

        {/* Dots nav */}
        <div className="flex items-center justify-center gap-3">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className="transition-all duration-300 rounded-full cursor-pointer"
              style={{
                width: i === active ? '32px' : '8px',
                height: '8px',
                background: i === active ? t.color : 'rgba(255,255,255,0.2)',
              }}
            />
          ))}
        </div>

        {/* Avatars row */}
        <div className="flex items-center justify-center gap-4 mt-8">
          {TESTIMONIALS.map((item, i) => (
            <button
              key={item.id}
              onClick={() => goTo(i)}
              className="transition-all duration-300 rounded-full overflow-hidden cursor-pointer"
              style={{
                width: i === active ? '52px' : '40px',
                height: i === active ? '52px' : '40px',
                opacity: i === active ? 1 : 0.4,
                border: i === active ? `2px solid ${t.color}` : '2px solid transparent',
              }}
            >
              <img src={item.avatar} alt={item.name} className="w-full h-full object-cover object-top" />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
